import n, { createContext as e, useContext as t, useState as r, forwardRef as o, useRef as i, useMemo as a, useEffect as l } from "react";
import s from "prop-types";
import { Transition as c } from "react-transition-group";
import { useIdAllocator as d, useEventListener as p } from "@leafygreen-ui/hooks";
import { css as u, cx as m } from "@leafygreen-ui/emotion";
import { createUniqueClassName as f, keyMap as g, AriaCurrentValue as h, isComponentType as b } from "@leafygreen-ui/lib";
import { prefersReducedMotion as y, validateAriaLabelProps as v } from "@leafygreen-ui/a11y";
import { useUsingKeyboardContext as x } from "@leafygreen-ui/leafygreen-provider";
import { InlineKeyCode as N, useUpdatedBaseFontSize as E, Overline as k } from "@leafygreen-ui/typography";
import { fontFamilies as w, spacing as S, typeScales as C, BaseFontSize as O } from "@leafygreen-ui/tokens";
import { palette as I } from "@leafygreen-ui/palette";
import { transparentize as j } from "polished";
import z from "@leafygreen-ui/tooltip";
import T from "@leafygreen-ui/icon/dist/ChevronRight";
import A from "@leafygreen-ui/icon/dist/ChevronLeft";
import F from "@leafygreen-ui/box";
import L from "@leafygreen-ui/portal";
import { isComponentGlyph as P } from "@leafygreen-ui/icon";

function B(n) {
  return B = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (n) {
    return typeof n;
  } : function (n) {
    return n && "function" == typeof Symbol && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, B(n);
}

function R(n, e, t) {
  return e in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}

function G() {
  return G = Object.assign || function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];

      for (var r in t) {
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
      }
    }

    return n;
  }, G.apply(this, arguments);
}

function K(n, e) {
  if (null == n) return {};

  var t,
      r,
      o = function (n, e) {
    if (null == n) return {};
    var t,
        r,
        o = {},
        i = Object.keys(n);

    for (r = 0; r < i.length; r++) {
      t = i[r], e.indexOf(t) >= 0 || (o[t] = n[t]);
    }

    return o;
  }(n, e);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(n);

    for (r = 0; r < i.length; r++) {
      t = i[r], e.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(n, t) && (o[t] = n[t]);
    }
  }

  return o;
}

function U(n, e) {
  return e || (e = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

function M(n, e) {
  return function (n) {
    if (Array.isArray(n)) return n;
  }(n) || function (n, e) {
    var t = null == n ? null : "undefined" != typeof Symbol && n[Symbol.iterator] || n["@@iterator"];
    if (null == t) return;
    var r,
        o,
        i = [],
        a = !0,
        l = !1;

    try {
      for (t = t.call(n); !(a = (r = t.next()).done) && (i.push(r.value), !e || i.length !== e); a = !0) {
        ;
      }
    } catch (n) {
      l = !0, o = n;
    } finally {
      try {
        a || null == t.return || t.return();
      } finally {
        if (l) throw o;
      }
    }

    return i;
  }(n, e) || function (n, e) {
    if (!n) return;
    if ("string" == typeof n) return V(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    "Object" === t && n.constructor && (t = n.constructor.name);
    if ("Map" === t || "Set" === t) return Array.from(n);
    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return V(n, e);
  }(n, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function V(n, e) {
  (null == e || e > n.length) && (e = n.length);

  for (var t = 0, r = new Array(e); t < e; t++) {
    r[t] = n[t];
  }

  return r;
}

var Y,
    H,
    W,
    D,
    X,
    $,
    q,
    J,
    Q,
    Z,
    _,
    nn,
    en,
    tn,
    rn,
    on,
    an,
    ln = f("side-nav"),
    sn = 16,
    cn = 184,
    dn = u(Y || (Y = U(["\n  margin-block-start: 0px;\n  margin-block-end: 0px;\n  padding-inline-start: 0px;\n  padding: 0;\n  list-style-type: none;\n"])));

function pn(n) {
  return u(H || (H = U(["\n    border-left: 3px solid ", ";\n    padding-left: ", "px;\n  "])), I.gray.light1, 8 + 8 * n);
}

var un,
    mn,
    fn,
    gn,
    hn,
    bn,
    yn,
    vn,
    xn = u(W || (W = U(["\n  position: relative;\n  transition: width ", "ms ease-in-out;\n\n  ", "\n"])), 200, y("\n    transition: none;\n  ")),
    Nn = u(D || (D = U(["\n  width: 48px;\n"]))),
    En = u(X || (X = U(["\n  /**\n   * Setting position: absolute; here so the nav wrapper can appear\n   * above the content in on the collapsed state. \n   */\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n"]))),
    kn = u($ || ($ = U(["\n  position: relative;\n  font-family: ", ";\n  background-color: ", ";\n  z-index: 0;\n  transition: ", "ms ease-in-out;\n  transition-property: box-shadow, border-color, width;\n\n  ", "\n"])), w.default, I.gray.light3, 200, y("\n    transition-property: box-shadow, border-color;\n  ")),
    wn = u(q || (q = U(["\n  box-shadow: 2px 0 4px ", ";\n"])), j(.9, I.black)),
    Sn = u(J || (J = U(["\n  width: 48px;\n"]))),
    Cn = u(Q || (Q = U(["\n  /**\n  * Setting position: absolute so the expanded and collapsed menus\n  * can be rendered in the same spot.\n  * We transition the opacity & transform to display one or the other.\n  */\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  overflow: hidden;\n  transition: ", "ms ease-in-out;\n  transition-property: opacity, transform;\n\n  ", "\n"])), 200, y("\n    transition: opacity ".concat(200, "ms ease-in-out;\n  "))),
    On = u(Z || (Z = U(["\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  padding-top: ", "px;\n  padding-bottom: ", "px;\n  overflow-x: hidden;\n  overflow-y: auto;\n"])), S[3], S[3]),
    In = u(_ || (_ = U(["\n  transform: translate3d(0, ", "px, 0);\n  opacity: 0;\n  pointer-events: none;\n"])), S[2]),
    jn = u(nn || (nn = U(["\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n"]))),
    zn = u(en || (en = U(["\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n"]))),
    Tn = u(tn || (tn = U(["\n  transform: translate3d(0, -", "px, 0);\n  opacity: 0;\n  pointer-events: none;\n"])), S[2]),
    An = {
  entering: In,
  entered: In,
  exiting: jn,
  exited: jn
},
    Fn = {
  entering: zn,
  entered: zn,
  exiting: Tn,
  exited: Tn
},
    Ln = (R(an = {}, O.Body1, u(rn || (rn = U(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), C.body1.fontSize, C.body1.lineHeight)), R(an, O.Body2, u(on || (on = U(["\n    font-size: ", "px;\n    line-height: ", "px;\n  "])), C.body2.fontSize, C.body2.lineHeight)), an),
    Pn = e({
  collapsed: !1,
  width: 184,
  baseFontSize: O.Body1
}),
    Bn = function Bn() {
  return t(Pn);
},
    Rn = ["className", "collapsed", "hideTooltip"],
    Gn = f("collapse-menu"),
    Kn = u(un || (un = U(["\n  position: absolute;\n  bottom: ", "px;\n  right: -", "px;\n  width: ", "px;\n  height: ", "px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 100%;\n\n  color: ", ";\n  box-shadow: 0 3px 4px ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  cursor: pointer;\n  transition: 150ms ease-in-out;\n  transition-property: color, border-color, box-shadow;\n\n  &:hover {\n    background-color: ", ";\n    box-shadow: 0 2px 2px ", ";\n\n    .", " {\n      transform: translate3d(-2px, 0, 0);\n    }\n  }\n\n  &:focus {\n    outline: none;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n"])), S[3], S[3], S[5], S[5], I.green.dark2, j(.9, I.black), I.white, I.gray.light2, I.gray.light3, j(.8, I.black), Gn),
    Un = u(mn || (mn = U(["\n  &:focus {\n    color: ", ";\n    border-color: transparent;\n    box-shadow: 0 3px 4px ", ",\n      // Focus ring\n      0 0 0 2px ", ",\n      0 0 0 4px ", ";\n  }\n"])), I.blue.base, j(.9, I.black), I.white, I.blue.light1),
    Mn = u(fn || (fn = U(["\n  &:hover {\n    .", " {\n      transform: translate3d(2px, 0, 0);\n    }\n  }\n"])), Gn),
    Vn = u(gn || (gn = U(["\n  transition: transform 80ms ease-in-out;\n  display: inline-block;\n  height: 16px;\n\n  ", "\n"])), y("\n    transition-property: unset;\n  ")),
    Yn = u(hn || (hn = U(["\n  background-color: ", ";\n  color: ", ";\n  border-color: ", ";\n  padding: 0 3px 2px 2px;\n  box-shadow: 0 3px 3px -2px rgba(113, 39, 39, 0.3), 0 0 2px rgba(0, 0, 0, 0.3),\n    inset 0 1px 2px rgba(255, 255, 255, 0.15);\n  line-height: 1em;\n  margin-left: ", "px;\n"])), I.gray.dark2, I.white, I.gray.dark1, S[2]);

function Hn(e) {
  var t,
      r = e.className,
      o = e.collapsed,
      i = e.hideTooltip,
      a = K(e, Rn),
      l = x().usingKeyboard,
      s = Bn().navId,
      c = o ? T : A;
  return n.createElement(z, {
    align: "right",
    justify: "middle",
    open: "boolean" == typeof i ? !i : void 0,
    trigger: n.createElement("button", G({
      "data-testid": "side-nav-collapse-toggle",
      "aria-label": "Collapse navigation",
      "aria-controls": s,
      "aria-expanded": !o,
      className: m(Kn, (t = {}, R(t, Un, l), R(t, Mn, o), t), r)
    }, a), n.createElement("div", {
      className: m(Gn, Vn)
    }, n.createElement(c, {
      role: "presentation"
    })))
  }, n.createElement("span", {
    "aria-hidden": !0
  }, o ? "Expand" : "Collapse", n.createElement(N, {
    className: Yn
  }, "[")));
}

var Wn,
    Dn,
    Xn = ["className", "children", "id", "baseFontSize", "widthOverride", "collapsed", "setCollapsed"],
    $n = ".".concat(ln);

function qn(e) {
  var t = e.className,
      o = e.children,
      i = e.id,
      a = e.baseFontSize,
      l = e.widthOverride,
      s = e.collapsed,
      f = e.setCollapsed,
      h = void 0 === f ? function () {} : f,
      b = K(e, Xn),
      y = Pn.Provider,
      N = M(r(!1), 2),
      k = N[0],
      w = N[1],
      S = E(a),
      C = x().usingKeyboard,
      O = M(r(!1), 2),
      I = O[0],
      j = O[1],
      z = M(r(!1), 2),
      T = z[0],
      A = z[1],
      F = d({
    prefix: "side-nav",
    id: i
  }),
      L = M(r(null), 2),
      P = L[0],
      B = L[1],
      V = "number" == typeof l ? l : 184,
      Y = "boolean" == typeof s ? s : k,
      H = "boolean" == typeof s ? h : w,
      W = C && T;
  return v(b, "SideNav"), p("keypress", function (n) {
    var e,
        t = ["INPUT", "TEXTAREA"].includes(null === (e = n.target) || void 0 === e ? void 0 : e.tagName);
    n.keyCode !== g.BracketLeft || t || H(function (n) {
      return !n;
    });
  }, {
    options: {
      passive: !0
    }
  }), n.createElement(c, {
    in: Y && !I && !W,
    timeout: 200
  }, function (e) {
    var r;
    return n.createElement(y, {
      value: {
        navId: F,
        collapsed: Y,
        portalContainer: P,
        width: V,
        transitionState: e,
        baseFontSize: S
      }
    }, n.createElement("div", {
      "data-testid": "side-nav-container",
      className: m(ln, xn, u(bn || (bn = U(["\n                width: ", "px;\n              "])), V), R({}, Nn, Y), t)
    }, n.createElement("div", {
      className: En,
      onMouseLeave: function onMouseLeave() {
        return j(!1);
      }
    }, n.createElement("nav", G({
      id: F,
      className: m(kn, u(yn || (yn = U(["\n                    width: ", "px;\n                  "])), V), (r = {}, R(r, Sn, ["entering", "entered"].includes(e)), R(r, wn, (I || W) && Y), r)),
      onFocus: function onFocus() {
        return A(!0);
      },
      onBlur: function onBlur() {
        return A(!1);
      },
      onMouseEnter: function onMouseEnter() {
        return j(!0);
      }
    }, b), n.createElement("div", {
      className: m(Cn, An[e])
    }, n.createElement("ul", {
      className: m(dn, On, u(vn || (vn = U(["\n                        width: ", "px;\n                      "])), V))
    }, o)), n.createElement("div", {
      className: m(Cn, Fn[e])
    }, n.createElement("ul", {
      "aria-hidden": !0,
      className: m(dn, On),
      ref: B
    }))), n.createElement(Hn, {
      collapsed: Y || !I && !W && Y,
      onClick: function onClick() {
        H(function (n) {
          return !n;
        }), j(!1);
      },
      hideTooltip: ["entering", "exiting"].includes(e) || void 0
    }))));
  });
}

qn.displayName = "SideNav", qn.propTypes = {
  className: s.string,
  children: s.node,
  id: s.string
};

var Jn,
    Qn,
    Zn,
    _n,
    ne,
    ee,
    te,
    re = u(Wn || (Wn = U(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 40px;\n  border-bottom: 1px solid ", ";\n  color: ", ";\n\n  &:first-of-type {\n    border-top: 1px solid ", ";\n  }\n"])), I.gray.light2, I.green.dark2, I.gray.light2),
    oe = u(Dn || (Dn = U(["\n  background-color: ", ";\n"])), I.green.light3);

function ie(e) {
  var t = e.children,
      r = e.active,
      o = void 0 !== r && r,
      i = e.className,
      a = Bn().portalContainer;
  return n.createElement(L, {
    container: a
  }, n.createElement("li", {
    className: m(re, R({}, oe, o), i)
  }, t));
}

var ae,
    le,
    se,
    ce,
    de,
    pe,
    ue,
    me,
    fe,
    ge,
    he,
    be,
    ye,
    ve = f("side-nav-item"),
    xe = u(Jn || (Jn = U(["\n  // Unset defaults\n  margin: 0;\n  appearance: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  // Layout\n  position: relative;\n  width: 100%;\n  min-height: 32px;\n  padding: 6px 16px;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n\n  // Typography\n  font-family: ", ";\n  font-weight: normal;\n  text-align: left;\n  text-decoration: none;\n  text-transform: capitalize;\n  color: ", ";\n\n  // Stateful transitions\n  transition: background-color 100ms ease-in-out;\n  background-color: ", ";\n\n  &:hover {\n    background-color: ", ";\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: none;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n  }\n\n  // Setup the active/focus wedge\n  &:before {\n    content: '';\n    position: absolute;\n    background-color: transparent;\n    left: 0;\n    top: 6px;\n    bottom: 6px;\n    width: ", "px;\n    border-radius: 0 6px 6px 0;\n    transition: transform 150ms ease-in-out;\n    transform: scaleY(0.3);\n  }\n"])), w.default, I.black, j(100, I.gray.light3), I.gray.light2, S[1]),
    Ne = u(Qn || (Qn = U(["\n  cursor: default;\n  font-weight: bold;\n  text-decoration: none;\n  color: ", ";\n\n  &,\n  &:hover {\n    background-color: ", ";\n  }\n\n  // The active wedge\n  &:before {\n    transform: scaleY(1);\n    background-color: ", ";\n  }\n"])), I.green.dark2, I.green.light3, I.green.dark1),
    Ee = u(Zn || (Zn = U(["\n  background-color: transparent;\n  font-weight: normal;\n  cursor: not-allowed;\n\n  &,\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), I.gray.base, j(100, I.gray.light3)),
    ke = u(_n || (_n = U(["\n  position: relative;\n\n  &:focus {\n    text-decoration: none;\n    color: ", ";\n    background-color: ", ";\n\n    // The focus wedge\n    &:before {\n      transform: scaleY(1);\n      background-color: ", ";\n    }\n  }\n"])), I.blue.dark3, I.blue.light2, I.blue.light1),
    we = u(ne || (ne = U(["\n  &:focus {\n    color: ", ";\n    background-color: ", ";\n\n    &:before {\n      content: unset;\n    }\n  }\n"])), I.blue.light1, j(.1, I.blue.light3)),
    Se = u(ee || (ee = U(["\n  margin-right: ", "px;\n  display: inline-flex;\n  align-items: center;\n"])), S[2]),
    Ce = u(te || (te = U(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n"]))),
    Oe = ["active", "disabled", "ariaCurrentValue", "indentLevel", "className", "children", "onClick", "glyph"],
    Ie = o(function (e, t) {
  var r,
      o = e.active,
      l = void 0 !== o && o,
      s = e.disabled,
      c = void 0 !== s && s,
      d = e.ariaCurrentValue,
      p = void 0 === d ? h.Page : d,
      f = e.indentLevel,
      g = void 0 === f ? 1 : f,
      y = e.className,
      v = e.children,
      N = e.onClick,
      E = e.glyph,
      k = K(e, Oe),
      w = x().usingKeyboard,
      S = Bn().baseFontSize,
      C = i(!1),
      O = c ? function (n) {
    n.nativeEvent.stopImmediatePropagation(), n.preventDefault();
  } : function (n) {
    null == N || N(n);
  },
      I = E && b(E, "Glyph") || b(E, "Icon") ? n.cloneElement(E, {
    "aria-hidden": !0
  }) : null,
      j = a(function () {
    var e = [],
        t = !1;

    function r(e) {
      var t = !1;
      return n.Children.forEach(e, function (n) {
        var e;
        t || (b(n, "SideNavItem") && n.props.active ? t = !0 : null != n && null !== (e = n.props) && void 0 !== e && e.children && "object" == B(n.props.children) && (t = r(n.props.children)));
      }), t;
    }

    return n.Children.forEach(v, function (o, i) {
      (null != o && b(o, "SideNavItem") || b(o, "SideNavGroup")) && (t = !0, (l || r(v)) && e.push(n.cloneElement(o, {
        indentLevel: g + 1,
        key: i
      })));
    }), {
      hasNestedItems: t,
      renderedNestedItems: e
    };
  }, [v, l, g]),
      z = j.hasNestedItems,
      T = j.renderedNestedItems,
      A = a(function () {
    var e = [];
    return n.Children.forEach(v, function (n) {
      return n ? b(n, "SideNavItem") || b(n, "SideNavGroup") ? null : void e.push(n) : null;
    }), e;
  }, [v]);
  return n.createElement("li", {
    className: u(ae || (ae = U(["\n        width: 100%;\n      "])))
  }, n.createElement(F, G({
    as: e.href ? "a" : "button"
  }, k, {
    className: m(ve, xe, Ln[S], (r = {}, R(r, Ne, l), R(r, Ee, c), R(r, ke, w), R(r, we, w && c), R(r, Ce, C.current), R(r, pn(g), g > 1), r), y),
    "aria-current": l ? p : h.Unset,
    "aria-disabled": c,
    ref: t,
    onClick: O
  }), I && n.createElement("span", {
    className: Se
  }, I, n.createElement(ie, {
    active: l
  }, I)), A), z && n.createElement("ul", {
    className: u(le || (le = U(["\n            list-style: none;\n            padding-inline-start: 0;\n          "])))
  }, T));
});
Ie.displayName = "SideNavItem", Ie.propTypes = {
  active: s.bool,
  disabled: s.bool,
  className: s.string,
  ariaCurrentValue: s.oneOf(Object.values(h)),
  children: s.node,
  href: s.string
};
var je,
    ze,
    Te,
    Ae,
    Fe,
    Le,
    Pe,
    Be = f("side-nav-group-button"),
    Re = u(se || (se = U(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n\n  & ~ & > .", " {\n    padding: 16px ", "px 8px ", "px;\n  }\n"])), Be, 16, 16),
    Ge = u(ce || (ce = U(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 0;\n  margin-bottom: 0;\n  padding: 16px 16px 8px;\n  color: ", ";\n"])), I.green.dark2),
    Ke = u(de || (de = U(["\n  background-color: transparent;\n  border: none;\n  margin: 0px;\n  transition: 100ms ease-in-out;\n  transition-property: border-color, background-color, color;\n  cursor: pointer;\n  border-bottom: 1px solid ", ";\n\n  &:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  &:focus {\n    outline: none;\n  }\n"])), I.gray.light2, I.gray.light2, I.green.dark1),
    Ue = u(pe || (pe = U(["\n  &:focus {\n    color: ", ";\n    border-color: ", ";\n    background-color: ", ";\n\n    & svg {\n      color: ", ";\n    }\n  }\n"])), I.blue.dark3, I.blue.light1, I.blue.light2, I.blue.base),
    Me = u(ue || (ue = U(["\n  margin-right: ", "px;\n\n  // When the glyph is the last child, we remove the margin\n  // used to space it from the text. This matters in the navigation\n  // collapsed state.\n  &:last-child {\n    margin-right: 0;\n  }\n"])), S[2]),
    Ve = u(me || (me = U(["\n  transition: 150ms all ease-in-out;\n  margin-left: ", "px;\n\n  ", "\n"])), S[2], y("\n    transition: none;\n  ")),
    Ye = u(fe || (fe = U(["\n  transform: rotate(90deg);\n"]))),
    He = u(ge || (ge = U(["\n  max-height: 0;\n  overflow: hidden;\n  opacity: 1;\n  transition: 150ms ease-in-out;\n  transition-property: opacity, max-height;\n\n  ", "\n"])), y("\n    transition: opacity 150ms ease-in-out;\n  ")),
    We = {
  entering: u(he || (he = U(["\n    opacity: 0;\n  "]))),
  entered: "",
  exiting: u(be || (be = U(["\n    opacity: 0;\n  "]))),
  exited: u(ye || (ye = U(["\n    opacity: 0;\n  "]))),
  unmounted: void 0
},
    De = ["header", "children", "collapsible", "initialCollapsed", "glyph", "className", "hasActiveItem", "indentLevel"];

function Xe(e) {
  var t,
      r = e.header,
      o = e.children,
      i = e.collapsible,
      s = void 0 !== i && i,
      p = e.initialCollapsed,
      f = void 0 === p || p,
      g = e.glyph,
      h = e.className,
      y = e.hasActiveItem,
      v = e.indentLevel,
      N = void 0 === v ? 0 : v,
      E = K(e, De),
      w = M(n.useState(!f), 2),
      S = w[0],
      C = w[1],
      O = n.useRef(null),
      j = n.useRef(null),
      z = x().usingKeyboard,
      A = d({
    prefix: "menu-group-label-id"
  }),
      F = d({
    prefix: "menu"
  }),
      L = Bn().width,
      B = a(function () {
    return function e(t) {
      return n.Children.map(t, function (t) {
        var r;
        return b(t, "SideNavGroup") || b(t, "SideNavItem") ? n.cloneElement(t, {
          indentLevel: N + 1
        }) : null != t && null !== (r = t.props) && void 0 !== r && r.children ? (e(t.props.children), t) : t;
      });
    }(o);
  }, [o, N]),
      V = a(function () {
    if (null != y) return y;
    return function e(t) {
      var r = !1;
      return n.Children.forEach(t, function (n) {
        var t;
        b(n, "SideNavItem") && n.props.active ? (r = !0, C(!0)) : null != n && null !== (t = n.props) && void 0 !== t && t.children && e(n.props.children);
      }), r;
    }(o);
  }, [y, o]),
      Y = g && (P(g) || b(g, "Icon")) ? n.cloneElement(g, {
    className: m(Me, g.props.className),
    role: "presentation",
    "data-testid": "side-nav-group-header-icon"
  }) : null,
      H = n.createElement("div", {
    className: u(je || (je = U(["\n        display: inline-flex;\n        align-items: center;\n      "])))
  }, Y && n.createElement(n.Fragment, null, Y, n.createElement(ie, {
    active: V
  }, Y)), n.createElement(k, {
    className: u(ze || (ze = U(["\n          color: inherit;\n        "])))
  }, r)),
      W = m(pn(N), u(Te || (Te = U(["\n      padding-top: 16px;\n      padding-bottom: 8px;\n    "]))));
  l(function () {
    var n,
        e,
        t = null !== (n = null == j || null === (e = j.current) || void 0 === e ? void 0 : e.getBoundingClientRect().height) && void 0 !== n ? n : 0;
    We.entered = u(Ae || (Ae = U(["\n      opacity: 1;\n      max-height: ", "px; // +1 for border\n      border-bottom: 1px solid ", ";\n    "])), t + 1, I.gray.light2);
  }, [S, j]);
  var D = {
    "data-testid": "side-nav-group-header-label",
    id: A
  };
  return n.createElement("li", G({
    className: m(Re, h)
  }, E), s ? n.createElement(n.Fragment, null, n.createElement("button", G({}, D, {
    "aria-controls": F,
    "aria-expanded": S,
    className: m(Be, Ge, Ke, u(Fe || (Fe = U(["\n                width: ", "px;\n              "])), L), (t = {}, R(t, Ue, z), R(t, W, N > 1), t)),
    onClick: function onClick() {
      return C(function (n) {
        return !n;
      });
    }
  }), H, n.createElement(T, {
    role: "presentation",
    size: 12,
    className: m(Ve, R({}, Ye, S))
  })), n.createElement(c, {
    in: S,
    appear: !0,
    timeout: 150,
    nodeRef: O,
    mountOnEnter: !0,
    unmountOnExit: !0
  }, function (e) {
    return n.createElement("div", {
      ref: O,
      className: m(He, We[e])
    }, n.createElement("ul", {
      ref: j,
      id: F,
      "aria-labelledby": A,
      className: m(dn, u(Le || (Le = U(["\n                      transition: opacity 150ms ease-in-out;\n                      opacity: 0;\n                    "]))), R({}, u(Pe || (Pe = U(["\n                        opacity: 1;\n                      "]))), ["entering", "entered"].includes(e)))
    }, B));
  })) : n.createElement(n.Fragment, null, n.createElement("div", G({}, D, {
    className: m(Ge, R({}, W, N > 1))
  }), H), n.createElement("ul", {
    "aria-labelledby": A,
    className: dn
  }, B)));
}

Xe.displayName = "SideNavGroup", Xe.propTypes = {
  className: s.string,
  header: s.oneOfType([s.string, s.func, s.node]),
  collapsible: s.bool,
  initialCollapsed: s.bool,
  glyph: s.node,
  children: s.node
};
export { ie as CollapsedSideNavItem, qn as SideNav, Xe as SideNavGroup, Ie as SideNavItem, sn as sideNavItemSidePadding, $n as sideNavSelector, cn as sideNavWidth };